import React from 'react';
import { CountLabel } from '@dealroadshow/uikit/core/components/Badge/CountLabel';
import { useLeagueTableContext } from '@/finsight/application/League/Table/LeagueTableContext';
import { COUNT_LABEL_BACKGROUND_COLOR } from './constants';
import { DEFAULT_TTM_SELECT_VALUE, TypeCompany } from '@/finsight/application/League/constants';

import styles from '@/finsight/ui/components/league/LeagueTablePage/leagueTablePage.scss';
import { useLeagueTableFiltersContext } from '@/finsight/application/League/Table/LeagueTableFiltersContext';

interface IProps {
  typeCompany: TypeCompany,
}

const stateCollections = {
  [TypeCompany.all]: 'companiesAllCollection',
  [TypeCompany.underwriter]: 'underwritersCollection',
  [TypeCompany.ratingAgency]: 'ratingAgenciesCollection',
};

const MAX_TOTAL_COUNT = 99;

const LeagueCountLabel = ({ typeCompany }: IProps) => {
  const { state } = useLeagueTableContext();
  const { state: filtersState } = useLeagueTableFiltersContext();
  const { totalCount } = state[stateCollections[typeCompany]];
  const { value: searchText } = filtersState.search;
  const { value: selectedPeriodValue } = filtersState.periods.leagueTable.selected;

  const { isFetching: isFetchingCompaniesAll } = state.companiesAllCollection;
  const { isFetching: isFetchingUnderwriters } = state.underwritersCollection;
  const { isFetching: isFetchingRatingAgencies } = state.ratingAgenciesCollection;

  const canShowCount = (
      !isFetchingCompaniesAll
      && !isFetchingUnderwriters
      && !isFetchingRatingAgencies
    ) &&
    (
      searchText !== ''
      || selectedPeriodValue !== DEFAULT_TTM_SELECT_VALUE
    );

  return (
    <CountLabel
      className={ styles.countLabel }
      maxTotalCount={ MAX_TOTAL_COUNT }
      backgroundColor={ COUNT_LABEL_BACKGROUND_COLOR }
      totalCount={ totalCount }
      canShowCount={ canShowCount }
    />
  );
};

export default LeagueCountLabel;
